import { useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput/DateInput';
import Filter from '../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import { theme } from '../../styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import { digitalServicesFetchAction } from '../../store/fetchActions/digitalServicesActions';
import formatCPF from '../../utils/functions/formatCPF';
import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import Information from '../../components/Information/Information';
import Modal from '../../components/Modal/Modal';
import verifyEmptyValues from '../../utils/verifyEmptyValues';
import convertObjToArrayDigitalServices from './ConvertObjToArrayServicoDigital';
const { mainColor, secondaryColor, rbmWhite, rbmBlack } = theme.colors;

export default function ServicosDigitais() {
  const dispatch = useDispatch();
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [ModalInfoData, setModalInfoData] = useState({});

  const [filter, setFilter] = useState({
    search: '',
    dataInicial: '',
    dataFinal: '',
    limit: 10,
    page: 1,
    status: 0,
  });

  useEffect(() => {
    dispatch(digitalServicesFetchAction(filter));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, dispatch]);

  const {
    dataDigitalServices,
    paginationDigitalServices,
    loadingDigitalServices,
    errorDigitalServices,
    messageDigitalServices,
  } = useSelector((state) => state.digitalServices);

  const { handleSubmit, control } = useForm({});

  const filterTable = (data) => {
    dispatch(digitalServicesFetchAction(data));
  };

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const detailDigitalServiceArray =
    convertObjToArrayDigitalServices(ModalInfoData);
  const arrayStatus = [
    { ID: '1', NOME: 'Aprovada' },
    { ID: '2', NOME: 'Negada' },
  ];

  const header = [
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'center',
    },
    { id: 'cpf/cnpj', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'tipo', name: 'TIPO', align: 'left' },
    { id: 'valor', name: 'VALOR PAGO', align: 'right' },
    { id: 'produto', name: 'PRODUTO', align: 'left' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];

  const formatDigitalStatusID = (id) => {
    let statusID = '';
    switch (id) {
      case 'APROVADA':
        statusID = '1';
        break;
      case 'CANCELADA':
        statusID = '3';
        break;
      default:
        statusID = id;
        break;
    }
    return statusID;
  };

  const body = dataDigitalServices?.map((digitalService) => {
    return {
      data: [
        {
          info: verifyEmptyValues(digitalService.DATA),
          align: 'center',
        },
        {
          info: formatCPF(verifyEmptyValues(digitalService.CPFCNPJ)),
          align: 'left',
        },
        {
          info: verifyEmptyValues(digitalService.NOME),
          align: 'left',
        },
        {
          info: verifyEmptyValues(digitalService.CARACTERISTICA),
          align: 'left',
        },
        {
          info: 'R$ ' + formatMoney(verifyEmptyValues(digitalService.VALOR)),
          align: 'right',
        },
        {
          info: verifyEmptyValues(digitalService.NOME_PRODUTO),
          align: 'left',
        },
        {
          info: digitalService.STATUS_ID ? (
            <StatusContainer
              code={formatDigitalStatusID(digitalService.STATUS_ID)}
              description={digitalService.DESCRICAO_STATUS}
            ></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
      ],
      onClick: () => inspectDigitalService(digitalService),
    };
  });

  const inspectDigitalService = (data) => {
    setModalInfoData(data);
    setIsModalInfoOpen(true);
  };

  const closeModalInfo = () => setIsModalInfoOpen(false);

  return (
    <Wrapper title="Serviços Digitais">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'27.042vw'}
                control={control}
                margin={'0 0 0 1.389vw'}
                inputProps={{ role: 'filter-text-input' }}
              />

              <SelectOptions
                label={'tipo'}
                width={'12.528vw'}
                name={'status'}
                control={control}
                options={arrayStatus}
                initialName={'Todos'}
                initialValue={'0'}
              />
              <DateInput
                label="Data de Início"
                name={'dataInicial'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'dataFinal'}
                control={control}
              />

              <Button
                backgroundColor={secondaryColor}
                width="12.153vw"
                margin={'0 1.389vw 0 0'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                roleName="button-buscar-logs"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pagesOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialValue={10}
                initialName={10}
              />
              <h5>
                Total de Registros: {paginationDigitalServices?.totalResult}
              </h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingDigitalServices ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingDigitalServices}
            error={errorDigitalServices}
            hasPagination={true}
            filter={filter}
            pagination={paginationDigitalServices}
            setFilter={setFilter}
            errorMessage={messageDigitalServices}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.limit}
          />
        )}
        <Modal
          open={isModalInfoOpen}
          close={closeModalInfo}
          title="Detalhes Serviço Digital"
          width={'45.889vw'}
        >
          <Information data={detailDigitalServiceArray} />
        </Modal>
      </div>
    </Wrapper>
  );
}
